import { ReactNode, useEffect, useState } from "react";
import SidebarLayout from "../sidebar/SidebarLayout";
import PageLoadSpinner from "../layout/PageLoadSpinner";
import WhatsappModuleDisabled from "./WhatsappModuleDisabled";
import { useAuth } from "../../services/firebase/auth";
import { getCompanyData } from "../../services/company";

// Envolve as rotas /whatsapp e /whatsapp-bot — decide ANTES de montar a
// página de verdade, então nenhum dos dois hooks/telas pesadas dessas
// páginas chega a rodar quando o módulo está desabilitado (evita buscar
// instância/conversa à toa numa conta sem WhatsApp).
function WhatsappModuleGate(props: { children: ReactNode }) {
  const auth = useAuth();
  const [status, setStatus] = useState<"loading" | "enabled" | "disabled">(
    "loading",
  );

  useEffect(() => {
    getCompanyData(auth).then((company) => {
      // undefined (empresa nunca teve esse campo salvo) = DESABILITADO —
      // confirmado que nenhuma conta em produção usa WhatsApp sem esse
      // campo true explicitamente, sem risco de regressão. Espelha o
      // mesmo default em voki-admin/src/pages/EditInfo.tsx.
      setStatus(company?.whatsappEnabled === true ? "enabled" : "disabled");
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.user]);

  if (status === "loading")
    return (
      <SidebarLayout>
        <PageLoadSpinner show />
      </SidebarLayout>
    );

  if (status === "disabled")
    return (
      <SidebarLayout>
        <WhatsappModuleDisabled />
      </SidebarLayout>
    );

  return <>{props.children}</>;
}

export default WhatsappModuleGate;
